import { Subscription } from 'rxjs';
import {
  ExportInterfaceConfigurationAdditionalStockLocation,
  ExportInterfaceConfigurationClearingItemFilter,
  IExportInterfaceConfigurationDetailsFileFilterBrandSubDTO,
} from '../../../../../../base/models/models.swagger.generated';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { ConfigurationFormCoordinatorService } from '../../configuration-form-coordinator.service';
import { TranslateModule } from '@ngx-translate/core';
import { ConfigurationFormFileFilterBrandSubComponent } from './configuration-form-file-filter-brand-sub/configuration-form-file-filter-brand-sub.component';
import { YesNoGroupButtonComponent } from '../../../../../../base/shared/yes-no-group-button/yes-no-group-button.component';
import { NumericTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { EnumDropDownListComponent } from 'src/app/base/shared/enum-drop-down-list/enum-drop-down-list.component';

@Component({
    selector: 'app-configuration-form-file-filter',
    templateUrl: './configuration-form-file-filter.component.html',
    styleUrls: ['./configuration-form-file-filter.component.scss'],
    imports: [
        ReactiveFormsModule,
        NumericTextBoxModule,
        YesNoGroupButtonComponent,
        ConfigurationFormFileFilterBrandSubComponent,
        TranslateModule,
        EnumDropDownListComponent
    ]
})

export class ConfigurationFormFileFilterComponent implements OnInit, OnDestroy {
  @Input()
  public brandSubBrandFilter: IExportInterfaceConfigurationDetailsFileFilterBrandSubDTO[] = [];
  public brandSubBrandIncludeFilter: IExportInterfaceConfigurationDetailsFileFilterBrandSubDTO[] = [];
  public ClearingItemFilter = ExportInterfaceConfigurationClearingItemFilter;
  public AdditionalStockLocation = ExportInterfaceConfigurationAdditionalStockLocation;

  private subscription: Subscription;

  constructor(
    private configurationFormCoordinatorService: ConfigurationFormCoordinatorService
  ) { }

  public get configurationFormFileFilter(): UntypedFormGroup {
    return this.configurationFormCoordinatorService.configurationFormFileFilter;
  }

  public onBrandSubFilterChanged(filteredItems) {
    this.configurationFormFileFilter.get('brandFilters').setValue(filteredItems);
  }

  public onBrandSubIncludeFilterChanged(filteredItems) {
    this.configurationFormFileFilter.get('brandSubIncludeFilters').setValue(filteredItems);
  }

  private initData() {
    this.brandSubBrandFilter = this.configurationFormFileFilter.get('brandFilters')?.value;
    this.brandSubBrandIncludeFilter = this.configurationFormFileFilter.get('brandSubIncludeFilters')?.value;
  }

  ngOnInit() {
    this.subscription = this.configurationFormCoordinatorService.configurationDetailsDTOUpdated.subscribe(data => {
      this.initData();
    })
    this.initData();
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
